import React from "react";
import "./Avatar.scss";

// Fontaine M25 — Spinner: the one loading indicator (V2 `spinner` / `spinner-button`).

/**
 * @param {"xs"|"sm"|"md"|"lg"} [size="md"]   12 · 16 · 24 · 32
 * @param {string} [label="Loading"]           announced to assistive tech
 * @param {boolean} [inline]                   sits in a line of text / a button
 * @param {"default"|"neutral"|"inverse"} [tone="default"]   default = accent head
 */
export default function Spinner({ size = "md", label = "Loading", inline = false, tone = "default", className = "", ...rest }) {
  const classes = ["ft-spinner", `ft-spinner--${size}`, `ft-spinner--${tone}`, inline ? "ft-spinner--inline" : "", className].filter(Boolean).join(" ");
  return <span className={classes} role="status" aria-label={label} {...rest} />;
}
